module.exports = __webpack_public_path__ + "static/media/Hound-Selected.7d882fff.png";